import React from 'react';
import TextBoxInput from 'components/Inputs/TextBoxInput/TextBoxInput';
import { Patient } from 'types/types';
import useValidator from 'hooks/useValidator';
import Button from 'components/Button/Button';

type FormProps = {
  patient: Patient;
  type: string;
  onSubmitReferral: (payload: Record<string, string>) => void;
};

function TherapyReferralForm({ patient, type, onSubmitReferral }: FormProps) {
  const [validator, showValidationMessage] = useValidator({});
  const [payload, setPayload] = React.useState({
    reasonForTherapist: '',
    referralNotes: '',
  });

  const handleSubmit = async () => {
    if (!validator.allValid()) {
      showValidationMessage(true);
      return;
    }

    onSubmitReferral({
      type,
      reasonForTherapist: payload.reasonForTherapist,
      notes: payload.referralNotes,
    });
  };

  return (
    <div className="space-y-5 -mt-2">
      <div>
        <h3 className="text-sm leading-8 mb-2">
          {`Why are you referring ${patient.firstName} to a therapist?`}
        </h3>
        <TextBoxInput
          name="reasonForTherapist"
          placeholder="Type your response here..."
          rows={5}
          value={payload.reasonForTherapist}
          onChange={event =>
            setPayload(fndPayload => ({ ...fndPayload, reasonForTherapist: event.target.value }))
          }
          className="peer-[.validator-error]/reasonForTherapist:!border-river-red peer-[.validator-error]/reasonForTherapist:!mb-5 
          peer-[.validator-error]/reasonForTherapist:focus:!ring-river-red"
          validator={validator.message(
            'reasonForTherapist',
            payload.reasonForTherapist,
            'required|string|min:2',
            {
              messages: {
                required: 'Please provide reason for referring to a therapist.',
              },
              className: 'peer/reasonForTherapist validator-error mt-3 top-[150px] ml-1',
            },
          )}
        />
      </div>
      <div>
        <h3 className="text-sm leading-8 mb-2">Add your referral notes or comments here:</h3>
        <TextBoxInput
          name="referralNotes"
          placeholder="Type your response here..."
          rows={5}
          value={payload.referralNotes}
          onChange={event =>
            setPayload(fndPayload => ({ ...fndPayload, referralNotes: event.target.value }))
          }
          className="peer-[.validator-error]/referralNotes:!border-river-red peer-[.validator-error]/referralNotes:!mb-5 
          peer-[.validator-error]/referralNotes:focus:!ring-river-red"
          validator={validator.message(
            'referralNotes',
            payload.referralNotes,
            'required|string|min:2',
            {
              messages: {
                required: 'Please add a referral notes or comments.',
              },
              className: 'peer/referralNotes validator-error mt-3 top-[150px] ml-1',
            },
          )}
        />
      </div>

      <div className="!mt-14 text-center">
        <Button label="Submit" onClick={() => handleSubmit()} className="!px-2 !min-w-[250px]" />
      </div>
    </div>
  );
}

export default TherapyReferralForm;
